import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

export const OrderCart = () => {
  return (
 <div className="page-content">
  {/* Start Container */}
  <div className="container-fluid">
    {/* ========== Page Title Start ========== */}
    <div className="row">
      <div className="col-12">
        <div className="page-title-box">
          <h4 className="mb-0 fw-semibold">Order Cart</h4>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="javascript: void(0);">Order</a>
            </li>
            <li className="breadcrumb-item active">Order Cart</li>
          </ol>
        </div>
      </div>
    </div>
    {/* ========== Page Title End ========== */}
    <div className="row">
        <div className="col-lg-6">
          <div className='card cart-detail'>
          <div className="card-body">
            <div className="row gy-3">
              <div className="col-sm-auto">
                <div className="rounded bg-light avatar-lg d-flex align-items-center justify-content-center">
                  <img
                    src="/images/product/p-1.png"
                    alt=""
                    className="avatar-lg"
                  />
                </div>
              </div>
              <div className="col-sm">
                <div className="ms-lg-3">
                  <a href="#!" className="fw-medium text-dark fs-18">
                    Men Black Slim Fit T-shirt
                  </a>
                  <div className="d-flex align-items-center gap-3 mt-2">
                    <p className="text-dark fw-medium">
                      Color : <span className="text-muted"> Dark </span>
                    </p>
                    <p className="text-dark fw-medium">
                      Size : <span className="text-muted"> M </span>
                    </p>
                  </div>
                  <div className="quantity mt-2">
                    <div className="input-step border bg-body-secondary p-1 rounded d-inline-flex overflow-visible">
                      <button
                        type="button"
                        className="minus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        className="text-dark text-center border-0 bg-body-secondary rounded h-100"
                        defaultValue={1}
                        min={0}
                        max={100}
                        readOnly=""
                      />
                      <button
                        type="button"
                        className="plus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-auto">
                <div className="text-lg-end">
                  <p className="fw-medium mb-0">Items Price</p>
                  <p className="mt-2 mb-0 fw-semibold fs-17">
                    $80.00 <span className="fw-normal fs-14">/ $3.00 Tex</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer bg-light-subtle">
            <div className="row g-3">
              <div className="col-sm">
                <div className="d-flex gap-3">
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1"
                  >
                    <iconify-icon
                      icon="solar:trash-bin-minimalistic-bold-duotone"
                      className="fs-18"
                    />{" "}
                    Edit
                  </a>
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1 ms-3"
                  >
                    <iconify-icon
                      icon="solar:heart-bold-duotone"
                      className="fs-18"
                    />
                    Delete
                  </a>
                </div>
              </div>
              <div className="col-sm-auto">
                <p className="text-dark fw-medium mb-0">
                  Total : <span className="text-muted">$83.00</span>
                </p>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className='card cart-detail'>
          <div className="card-body">
            <div className="row gy-3">
              <div className="col-sm-auto">
                <div className="rounded bg-light avatar-lg d-flex align-items-center justify-content-center">
                  <img
                    src="/images/product/p-5.png"
                    alt=""
                    className="avatar-lg"
                  />
                </div>
              </div>
              <div className="col-sm">
                <div className="ms-lg-3">
                  <a href="#!" className="fw-medium text-dark fs-18">
                    Dark Green Cargo Pent
                  </a>
                  <div className="d-flex align-items-center gap-3 mt-2">
                    <p className="text-dark fw-medium">
                      Color : <span className="text-muted"> Dark Green</span>
                    </p>
                    <p className="text-dark fw-medium">
                      Size : <span className="text-muted"> M </span>
                    </p>
                  </div>
                  <div className="quantity mt-2">
                    <div className="input-step border bg-body-secondary p-1 rounded d-inline-flex overflow-visible">
                      <button
                        type="button"
                        className="minus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        className="text-dark text-center border-0 bg-body-secondary rounded h-100"
                        defaultValue={3}
                        min={0}
                        max={100}
                        readOnly=""
                      />
                      <button
                        type="button"
                        className="plus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-auto">
                <div className="text-lg-end">
                  <p className="fw-medium mb-0">Items Price</p>
                  <p className="mt-2 mb-0 fw-semibold fs-17">
                    $330.00 <span className="fw-normal fs-14">/ $4.00 Tex</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer bg-light-subtle">
            <div className="row g-3">
              <div className="col-sm">
                <div className="d-flex gap-3">
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1"
                  >
                    <iconify-icon
                      icon="solar:trash-bin-minimalistic-bold-duotone"
                      className="fs-18"
                    />{" "}
                    Edit
                  </a>
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1 ms-3"
                  >
                    <iconify-icon
                      icon="solar:heart-bold-duotone"
                      className="fs-18"
                    />
                    Delete
                  </a>
                </div>
              </div>
              <div className="col-sm-auto">
                <p className="text-dark fw-medium mb-0">
                  Total : <span className="text-muted">$334.00</span>
                </p>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="col-lg-6">
           <div className='card cart-detail'>
          <div className="card-body">
            <div className="row gy-3">
              <div className="col-sm-auto">
                <div className="rounded bg-light avatar-lg d-flex align-items-center justify-content-center">
                  <img
                    src="/images/product/p-8.png"
                    alt=""
                    className="avatar-lg"
                  />
                </div>
              </div>
              <div className="col-sm">
                <div className="ms-lg-3">
                  <a href="#!" className="fw-medium text-dark fs-18">
                    Men Dark Brown Wallet
                  </a>
                  <div className="d-flex align-items-center gap-3 mt-2">
                    <p className="text-dark fw-medium">
                      Color : <span className="text-muted"> Brown</span>
                    </p>
                    <p className="text-dark fw-medium">
                      Size : <span className="text-muted"> S </span>
                    </p>
                  </div>
                  <div className="quantity mt-2">
                    <div className="input-step border bg-body-secondary p-1 rounded d-inline-flex overflow-visible">
                      <button
                        type="button"
                        className="minus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        className="text-dark text-center border-0 bg-body-secondary rounded h-100"
                        defaultValue={1}
                        min={0}
                        max={100}
                        readOnly=""
                      />
                      <button
                        type="button"
                        className="plus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-auto">
                <div className="text-lg-end">
                  <p className="fw-medium mb-0">Items Price</p>
                  <p className="mt-2 mb-0 fw-semibold fs-17">
                    $132.00 <span className="fw-normal fs-14">/ $5.00 Tex</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer bg-light-subtle">
            <div className="row g-3">
              <div className="col-sm">
                <div className="d-flex gap-3">
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1"
                  >
                    <iconify-icon
                      icon="solar:trash-bin-minimalistic-bold-duotone"
                      className="fs-18"
                    />{" "}
                    Edit
                  </a>
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1 ms-3"
                  >
                    <iconify-icon
                      icon="solar:heart-bold-duotone"
                      className="fs-18"
                    />
                    Delete
                  </a>
                </div>
              </div>
              <div className="col-sm-auto">
                <p className="text-dark fw-medium mb-0">
                  Total : <span className="text-muted">$137.00</span>
                </p>
              </div>
            </div>
          </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className='card cart-detail'>
          <div className="card-body">
            <div className="row gy-3">
              <div className="col-sm-auto">
                <div className="rounded bg-light avatar-lg d-flex align-items-center justify-content-center">
                  <img
                    src="/images/product/p-10.png"
                    alt=""
                    className="avatar-lg"
                  />
                </div>
              </div>
              <div className="col-sm">
                <div className="ms-lg-3">
                  <a href="#!" className="fw-medium text-dark fs-18">
                    Kid's Yellow T-shirt
                  </a>
                  <div className="d-flex align-items-center gap-3 mt-2">
                    <p className="text-dark fw-medium">
                      Color : <span className="text-muted"> Yellow </span>
                    </p>
                    <p className="text-dark fw-medium">
                      Size : <span className="text-muted"> S </span>
                    </p>
                  </div>
                  <div className="quantity mt-2">
                    <div className="input-step border bg-body-secondary p-1 rounded d-inline-flex overflow-visible">
                      <button
                        type="button"
                        className="minus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        -
                      </button>
                      <input
                        type="number"
                        className="text-dark text-center border-0 bg-body-secondary rounded h-100"
                        defaultValue={2}
                        min={0}
                        max={100}
                        readOnly=""
                      />
                      <button
                        type="button"
                        className="plus bg-light text-dark border-0 rounded-1 fs-20 lh-1 h-100"
                      >
                        +
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-auto">
                <div className="text-lg-end">
                  <p className="fw-medium mb-0">Items Price</p>
                  <p className="mt-2 mb-0 fw-semibold fs-17">
                    $220.00 <span className="fw-normal fs-14">/ $3.00 Tex</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="card-footer bg-light-subtle">
            <div className="row g-3">
              <div className="col-sm">
                <div className="d-flex gap-3">
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1"
                  >
                    <iconify-icon
                      icon="solar:trash-bin-minimalistic-bold-duotone"
                      className="fs-18"
                    />{" "}
                    Edit
                  </a>
                  <a
                    href="#!"
                    className="text-dark fs-14 d-flex align-items-center gap-1 ms-3"
                  >
                    <iconify-icon
                      icon="solar:heart-bold-duotone"
                      className="fs-18"
                    />
                    Delete
                  </a>
                </div>
              </div>
              <div className="col-sm-auto">
                <p className="text-dark fw-medium mb-0">
                  Total : <span className="text-muted">$223.00</span>
                </p>
              </div>
            </div>
          </div>
          </div>
        </div>
    </div>
  </div>
</div>

  )
}

export const CartAdd = () => {
  const navigate = useNavigate();
  const initialFormState = {
    product_name: "",
    color: "",
    size: "",
    quantity: 1,
    price: "",
    tax: "",
    status: "",
  };

  const [CartItem, setCartItem] = useState(initialFormState);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCartItem({ ...CartItem, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_Cart",
        CartItem
      );

      if (response.data.status === true) {
        toast.success(response.data.message || "Cart item added successfully!");
        navigate("/cart-list");
      } else {
        toast.error(response.data.error || "Failed to add data");
      }
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Cart Add</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0);">Cart</a>
                </li>
                <li className="breadcrumb-item active">Cart Add</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Add Cart Form */}
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Cart Item</h4>
              </div>
              <form onSubmit={submitForm}>
                <div className="card-body">
                  <div className="row">
                    {/* Product Name */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label text-dark">
                          Product Name
                        </label>
                        <input
                          type="text"
                          name="product_name"
                          value={CartItem.product_name}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter product name"
                          required
                        />
                      </div>
                    </div>

                    {/* Color */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label text-dark">Color</label>
                        <input
                          type="text"
                          name="color"
                          value={CartItem.color}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter color"
                        />
                      </div>
                    </div>

                    {/* Size */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label text-dark">Size</label>
                        <input
                          type="text"
                          name="size"
                          value={CartItem.size}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter size"
                        />
                      </div>
                    </div>

                    {/* Quantity */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label text-dark">Quantity</label>
                        <input
                          type="number"
                          name="quantity"
                          value={CartItem.quantity}
                          onChange={handleInput}
                          className="form-control"
                          min="1"
                          max="100"
                        />
                      </div>
                    </div>

                    {/* Price */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label text-dark">Price</label>
                        <input
                          type="number"
                          name="price"
                          value={CartItem.price}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter price"
                        />
                      </div>
                    </div>

                    {/* Tax */}
                    <div className="col-lg-6">
                      <div className="mb-3">
                        <label className="form-label text-dark">Tax</label>
                        <input
                          type="number"
                          name="tax"
                          value={CartItem.tax}
                          onChange={handleInput}
                          className="form-control"
                          placeholder="Enter tax"
                        />
                      </div>
                    </div>

                    {/* Status */}
                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <select
                        name="status"
                        value={CartItem.status}
                        onChange={handleInput}
                        className="form-control"
                        required
                      >
                        <option value="">-- Select Status --</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className="card-footer border-top">
                  <button type="submit" className="btn btn-primary">
                    Save Change
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CartEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [CartItem, setCartItem] = useState({
    product_name: "",
    color: "",
    size: "",
    quantity: 1,
    price: "",
    tax: "",
    status: "",
  });

  useEffect(() => {
    // Fetch existing cart item
    const fetchCart = async () => {
      try {
        const response = await axios.get(
          `https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_Cart/${id}`
        );
        if (response.data.status === true) {
          setCartItem(response.data.data);
        } else {
          toast.error("Failed to load cart data");
        }
      } catch (error) {
        console.error("API Error:", error.response || error.message);
        toast.error("Something went wrong!");
      }
    };

    fetchCart();
  }, [id]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setCartItem({ ...CartItem, [name]: value });
  };

  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        `https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_Cart/${id}`,
        CartItem
      );

      if (response.data.status === true) {
        toast.success("Cart updated successfully!");
        navigate("/cart-list");
      } else {
        toast.error("Failed to update cart");
      }
    } catch (error) {
      console.error("API Error:", error.response || error.message);
      toast.error("Something went wrong!");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <h4 className="mb-3">Edit Cart Item</h4>
        <form onSubmit={submitForm}>
          <div className="row">
            {/* Reuse same fields as CartAdd.js */}
            <div className="col-lg-6 mb-3">
              <label className="form-label">Product Name</label>
              <input
                type="text"
                name="product_name"
                value={CartItem.product_name}
                onChange={handleInput}
                className="form-control"
              />
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">Color</label>
              <input
                type="text"
                name="color"
                value={CartItem.color}
                onChange={handleInput}
                className="form-control"
              />
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">Size</label>
              <input
                type="text"
                name="size"
                value={CartItem.size}
                onChange={handleInput}
                className="form-control"
              />
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">Quantity</label>
              <input
                type="number"
                name="quantity"
                value={CartItem.quantity}
                onChange={handleInput}
                className="form-control"
              />
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">Price</label>
              <input
                type="number"
                name="price"
                value={CartItem.price}
                onChange={handleInput}
                className="form-control"
              />
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">Tax</label>
              <input
                type="number"
                name="tax"
                value={CartItem.tax}
                onChange={handleInput}
                className="form-control"
              />
            </div>

            <div className="col-lg-6 mb-3">
              <label className="form-label">Status</label>
              <select
                name="status"
                value={CartItem.status}
                onChange={handleInput}
                className="form-control"
              >
                <option value="">-- Select Status --</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
          </div>

          <button type="submit" className="btn btn-primary">
            Update Cart
          </button>
        </form>
      </div>
    </div>
  );
};
